export enum AnalyzerResult {
  Loading = 1,
  Done = 2
}
